import styled from 'styled-components';

import { colors, sizes } from '@crm-framework/theme';

export const ErrorMessageWrapper = styled.span`
  padding: 8px;
  border-radius: ${sizes.DEFAULT_BORDER_RADIUS};
  border: 1px solid ${colors.DANGER};
  display: block;
`;

export const SectionHeader = styled.div`
  gap: 20px;
  display: flex;
  align-items: center;
  font-size: 1.17em;
  font-weight: 600;
`;
